import { render, staticRenderFns } from "./DemoModal.vue?vue&type=template&id=62dda645&scoped=true"
import script from "./DemoModal.vue?vue&type=script&lang=js"
export * from "./DemoModal.vue?vue&type=script&lang=js"
import style0 from "./DemoModal.vue?vue&type=style&index=0&id=62dda645&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dda645",
  null
  
)

export default component.exports